import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FilterComponent } from 'ag-grid-community/dist/lib/components/framework/componentTypes';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-payrollsummaryreport',
  templateUrl: './payrollsummaryreport.component.html',
  styleUrls: ['./payrollsummaryreport.component.css']
})
export class PayrollsummaryreportComponent implements OnInit {

  
  @ViewChild('filterbar',{static:false}) filterbar;
  
  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  
  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "PayrollSummaryReport";

  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = "ALL";
  payrollColl: any = [];

  

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Pay Period', field: 'payperiod' }, 
    {
      headerName: 'Start On', field: 'startdt', type:'date'
    },
    {
      headerName: 'End On', field: 'enddt',type:'date'
    },
    { headerName: 'Branch', field: 'branchname' }, 
    { headerName: 'PayRollGroup', field: 'payrollgrpname', }, 
   
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 

  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if(params.status!==undefined){
        this.filterstatus = params.status
      }  
    })
    
    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    try {

     
        this.fngetPayrollReport();
     

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }
 

  fnActionExportClick()  {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: 'bonuslist',
        //columnSeparator: document.querySelector("#columnSeparator").value
      };
      
  }

  fnActionFilterClick() {  

    this.filterbar.filterstatus = this.filterstatus;
    
    this.isfilter = !this.isfilter;
  }
  fnActionRefreshClick() { 
    this.fngetPayrollReport()
  }
  fnApplyFilter(data) {
    this.isfilter = !this.isfilter;

    this.filterstatus = data.status;

    this.fngetPayrollReport();
     
  }

  fnCurrentRouteChange() { 
    var queryParams = {};
    

    if (this.filterstatus != '') {     
      queryParams['status'] = this.filterstatus;
    }   

     this.router.navigate(
      [], 
      {
        relativeTo: this.route,
        queryParams: queryParams, 
      
      });
  }
  
  fnRemoveFilter(type) {
    
    if(type==='INACTIVE'){
      this.filterstatus="";
      this.fngetPayrollReport();     
    }  
    else{
      this.filterstatus="";
      this.fngetPayrollReport();    
    }
  }
  

  //Get
  fngetPayrollReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();   
    var data = {
      'payrollid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus':this.filterstatus,  
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
    }
    this.appService.getPayrollSummaryReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress(); 
            this.payrollColl = res.json().result;

            this.fnCurrentRouteChange();

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress(); 
          this.toastr.error('Error', err);
        })
  }


  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.payrollColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }




  public fnSearchDatatable(value){    
    
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.payrollColl[index].hoverfocus="IN"
      }
      else{
        this.payrollColl[index].hoverfocus=""
      }                
    }    
}
fnCloseForm(){
  try{
    this.router.navigate(['/Reports']);
  }catch(ex){
     this.fnShowErrorMsg(ex);
  }
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }  

fnFormatDatetime(dt){
  if(dt){
    if(dt===""){
      return null
    }
    else{
      return this.datePipe.transform(dt,"yyyy-MM-dd")  
    }
    
    }else {
    return null
  }
  
}

private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








  
}
  
  
